
export const isSessionStorageAvailable = (): boolean => {
  try {
    return typeof window !== 'undefined' && window.sessionStorage !== undefined;
  } catch {
    return false;
  }
};

export const getSessionStorageItem = (key: string): string | null => {
  if (!isSessionStorageAvailable()) return null;
  
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
};

export const setSessionStorageItem = (key: string, value: string): void => {
  if (!isSessionStorageAvailable()) return;
  
  try {
    sessionStorage.setItem(key, value);
  } catch {
    // Silently fail if sessionStorage is not available
  }
};

export const removeSessionStorageItem = (key: string): void => {
  if (!isSessionStorageAvailable()) return;
  
  try {
    sessionStorage.removeItem(key);
  } catch {
    // Silently fail if sessionStorage is not available
  }
};

export const clearSessionStorage = (): void => {
  if (!isSessionStorageAvailable()) return;
  
  try {
    sessionStorage.clear();
  } catch {
    // Silently fail if sessionStorage is not available
  }
};
